// eventBus.ts
import EventEmitter from 'eventemitter3';

// Optionally, define types for your events
type Events = {
  'click-refusal-event': string;
  'click-apply-event': string;
};

export const eventBus = new EventEmitter<Events>();
